export default __webpack_public_path__ + "static/media/Ebay.8b72bce3.svg";